/* eslint-disable */
import React, { useCallback, useState, useImperativeHandle, forwardRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useMount, useUpdateEffect, usePrevious } from 'react-use'
import dayjs from 'dayjs'
import qs from 'qs'
import { Button, Table, Breadcrumb, Divider } from 'antd'

import * as actions from '@/models/referralRule/actions'
import * as selectors from '@/models/referralRule/selectors'
import styles from './referalrule.module.scss'
import ReferralRuleDialog from '@/components/dialogs/ReferralRuleDialog'

function getColumns({ fetch }) {
  const dispatch = useDispatch()

  const showReferralRuleDialog = useCallback(item => event => {
    event.preventDefault()
    dispatch(actions.showInfoDialog({
      rule: item,
      title: '编辑规则',
      ismodify: "modify",
      submitCallback: () => { fetch() }
    }))
  })
  const deleteReferralRule = useCallback(item => event => {
    event.preventDefault()
    dispatch(actions.deleteRule(item._id))
  })
  return [
    {
      key: '_id',
      title: '',
      width: 30,
      render: (text, record, idx) => <div style={{ whiteSpace: 'nowrap' }}>{idx + 1}.</div>
    },
    {
      title: '最小单数',
      render: item => (
        <div>
          <div>{item.minOrder}</div>
        </div>
      )
    },
    {
      title: '最大单数',
      render: item => (
        <div>
          <div>{item.maxOrder}</div>
        </div>
      )
    },
    {
      title: '延期天数',
      render: item => (
        <div>
          <div>{item.days}</div>
        </div>
      )
    },
    {
      title: '是否启用',
      render: item => (
        <div>
          <div>{item.isActive ? '是' : '否'}</div>
        </div>
      )
    },
    {
      title: '创建时间',
      render: item => (
        <div>
          {item.createdAt ? dayjs(item.createdAt).fromNow() : '-'}
        </div>
      )
    },

    {
      title: '操作',
      render: item => {
        return (
          <div>
            <a onClick={showReferralRuleDialog(item)}>编辑</a>
            <Divider type="vertical" />
            <a onClick={deleteReferralRule(item)}>删除</a>
          </div>
        )
      }
    }
  ]
}

function ReferralRuleList(props, ref) {
  const dispatch = useDispatch()

  const loading = useSelector(selectors.loadingSelector)
  const total = useSelector(selectors.totalSelector)
  const mgroups = useSelector(selectors.entriesSelectors)

  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);

  useImperativeHandle(ref, () => ({
    add() {
      showInfoDialog('延期规则')
    },
  }));

  const pagination = {
    showQuickJumper: true,
    total: total,
    pageSize: +limit,
    current: Math.floor(offset / +limit) + 1
  }
  const fetch = useCallback((params = {}) => {
    params.offset = params.offset || offset
    params.limit = params.limit || limit
    setLimit(params.limit)
    setOffset(params.offset)
    dispatch(actions.fetchList(params))
  }, [])
  const showInfoDialog = (title) => {
    dispatch(actions.showInfoDialog({
      title,
      rule: {},
      submitCallback: () => { fetch() }
    })
    )
  }

  const handleTableChange = useCallback((pagination, filters, sorter) => {
    const nextQuery = {
      ...filters,
      offset: (pagination.current - 1) * pagination.pageSize
    }

    if (sorter && sorter.field) {
      nextQuery.sort = (sorter.order && sorter.order === 'descend' ? '' : '-') + sorter.field
    }
    fetch(nextQuery)
  })

  const columns = getColumns({ fetch })

  useMount(() => {
    fetch()
  })

  return (
    <div className={styles.container}>
      {/* <div className={styles.header}>
        <Breadcrumb>
          <Breadcrumb.Item>推广员</Breadcrumb.Item>
          <Breadcrumb.Item>延期规则</Breadcrumb.Item>
        </Breadcrumb>
        <Button size="small" onClick={() => { showInfoDialog('延期规则') }}>添加规则</Button>
      </div> */}
      <Table
        className={styles.table}
        columns={columns}
        rowKey="_id"
        dataSource={mgroups.toJS()}
        pagination={pagination}
        onChange={handleTableChange}
        loading={loading}></Table>
      <ReferralRuleDialog />
    </div>
  )
}

export default forwardRef(ReferralRuleList)
